<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-20 15:40:15
 * @LastEditTime: 2020-08-07 09:35:29
-->
<template>
  <div class="filter">
    <div class="filter-box">
      <label>项目名称：</label>
      <Input v-model="filter.projectName" placeholder="请输入" style="width:160px"></Input>
    </div>
    <div class="filter-box">
      <label>项目编号：</label>
      <Input v-model="filter.projectCode" placeholder="请输入" style="width:160px"></Input>
    </div>
    <div class="filter-box">
      <label>排名：</label>
      <Input
        v-model="filter.beginSort"
        placeholder="请输入"
        style="width:80px"
        @input="onSearch(1)"></Input>
      <label class="centerLine">-</label>
      <Input
        v-model="filter.endSort"
        placeholder="请输入"
        style="width:80px"
        @input="onSearch(2)"></Input>
    </div>
    <div class="filter-box">
      <label>票数：</label>
      <Input
        v-model="filter.minTicket"
        placeholder="请输入"
        style="width:80px"
        @input="onSearch(3)"></Input>
      <label class="centerLine">-</label>
      <Input
        v-model="filter.maxTicket"
        placeholder="请输入"
        style="width:80px"
        @input="onSearch(4)"></Input>
    </div>
    <div class="filter-box">
      <Button type="primary" @click="search">搜索</Button>
      <Button @click="goReset">重置</Button>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      filter: {
        projectName: '',
        projectCode: '',
        beginSort: '',
        endSort: '',
        minTicket: '',
        maxTicket: '',
      },
    }
  },
  computed: {
    nickname() {
      return this.$store.state['jurisprudenceDaily/projectManagement/card']
    },
    // ...mapGetters(['jurisprudenceDaily/projectManagement/getCard']),
    // card() {
    //   // return this.$store.getters['jurisprudenceDaily/projectManagement/getCard']
    //   // return this.$store.state['jurisprudenceDaily/projectManagement/card']
    // },
  },
  methods: {
    goReset() {
      this.filter = {
        projectName: '',
        projectCode: '',
        beginSort: '',
        endSort: '',
        minTicket: '',
        maxTicket: '',
      }
      this.$emit('reset', this.filter)
    },
    onSearch(val) {
      const reg = /^[0-9][0-9]{0,}$/
      if (val === 1 && !reg.test(this.filter.beginSort)) {
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          this.filter.beginSort = ''
        }, 0)
      }
      if (val === 2 && !reg.test(this.filter.endSort)) {
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          this.filter.endSort = ''
        }, 0)
      }
      if (val === 3 && !reg.test(this.filter.minTicket)) {
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          this.filter.minTicket = ''
        }, 0)
      }
      if (val === 4 && !reg.test(this.filter.maxTicket)) {
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          this.filter.maxTicket = ''
        }, 0)
      }
    },
    search() {
      this.$store.commit('jurisprudenceDaily/projectManagement/SET_USERINFO', '张三')
      this.$emit('query', this.filter)
    },
  },
}
</script>

<style lang='scss' scoped>
.filter {
  display: flex;
  > .filter-box {
    margin-right: 20px;
    button {
      margin-right: 10px;
    }
    label {
      width: 70px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 20px;
    }
    .centerLine {
      margin: 0 10px;
    }
  }
}
</style>